(function documentDetailControllerDefinition() {
    'use strict';

    angular.module('Document')
        .controller('DocumentDetailController', [
            '$filter', '$state', '$scope', '$stateParams', 'errorsExtend', 'processCustomerService', 'fileWorkflowService', 'authExtend', 'configViewService', '$q', 'fileDownloader', '$window', 'processService',
            function documentDetailController($filter, $state, $scope, $stateParams, errors, processCustomerService, fileWorkflowService, auth, configViewService, $q, fileDownloader, $window, processService) {

                $scope.preview = {
                    closed: true,
                    loading: false,
                    content: null,
                    index: null,
                    item: null,
                    invalid: false
                };

                $scope.loadDocument = function () {
                    var defered = $q.defer();
                    var promise = defered.promise;

                    processCustomerService.getById($stateParams.id).then(function (result) {
                        var found = $filter('filter')(result.metadataValues, { systemName: '_leido', value: 'N' }, true);
                        if (found.length > 0) {
                            processService.execute($stateParams.id).then(function (process) {
                                $scope.document = process;
                                defered.resolve();
                            }, function (error) {
                                errors.showError(error);
                                defered.reject();
                                //$scope.cancel();
                            });
                        } else {
                            $scope.document = result;
                            defered.resolve();
                        }
                    }, function (error) {
                        errors.showError(error);
                        defered.reject();
                        //$scope.cancel();
                    });

                    return promise;
                };

                $scope.loadConfigView = function () {
                    var defered = $q.defer();
                    var promise = defered.promise;

                    configViewService.getById('CPPDocument').then(function (result) {
                        $scope.configView = result;
                        defered.resolve();
                    }, function (error) {
                        errors.showError(error);
                        defered.reject();
                    });

                    return promise;
                }

                $scope.loadFile = function (fileId) {
                    return fileWorkflowService.getById(fileId)
                }

                $scope.previewFile = function (item, index) {
                    $scope.preview.content = null;
                    $scope.preview.loading = true;
                    $scope.preview.closed = false;
                    $scope.preview.invalid = false;

                    fileWorkflowService.preview(item, true).then(function (result) {
                        $scope.preview.content = result;
                        $scope.preview.item = item;
                        $scope.preview.index = index;
                        $scope.preview.loading = false;
                    }, function (error) {
                        if (error.data && error.data.modelState && error.data.modelState.no_converter) {
                            $scope.preview.loading = false;
                            $scope.preview.invalid = true;
                            $scope.preview.item = item;
                            $scope.preview.index = index;
                        }
                        else {
                            errors.showError(error);
                            //$scope.hidePreview();
                        }
                    });
                };

                $scope.cancel = function () {
                    $state.go('document-find');
                };

                $scope.edit = function () {
                    $state.go('document-edit', { id: $scope.document.id });
                };

                $scope.loadActions = function (processType, process) {
                    var result = $filter('filter')(processType.groupStates, function (item) {
                        return item.ids.indexOf(process.stateId) > -1;
                    }, true);

                    if (result.length > 0) {
                        $scope.actions = {
                            edit: result[0].edit,
                            editName: result[0].editName
                        };
                    }
                };

                $scope.load = function () {
                    $scope.actions = {
                        edit: false,
                        editName: 'Edit'
                    };

                    $scope.userId = auth.getUserId();
                    $scope.signPermission = auth.isInRole('DOCUMENTCUSTOMER SIGN');

                    var metadatas = [];

                    $q.all([$scope.loadDocument(), $scope.loadConfigView()]).then(function () {
                        var result = $filter('filter')($scope.configView.processTypes, { processTypeId: $scope.document.documentTypeId }, true);
                        if (result.length == 0) {
                            $scope.document.metadataValues = metadatas;
                            return;
                        }

                        result[0].metadatas.forEach(function (documentMetadata) {
                            if (documentMetadata.detailCriteria) {
                                var metadataFound = $filter('filter')($scope.document.metadataValues, { systemName: documentMetadata.systemName }, true);

                                var value = null;
                                var desc = null;

                                if (metadataFound.length > 0) {
                                    value = metadataFound[0].value;
                                    desc = metadataFound[0].description;
                                }

                                metadatas.push({
                                    metadataId: documentMetadata.metadataId,
                                    type: documentMetadata.metadataType != null ? documentMetadata.metadataType.toLowerCase() : undefined,
                                    name: documentMetadata.detailCriteria.name,
                                    isVisible: true,
                                    maskOptions: documentMetadata.maskOptions,
                                    systemName: documentMetadata.systemName,
                                    order: documentMetadata.detailCriteria.order,
                                    value: value,
                                    description: desc,
                                    mask: documentMetadata.detailCriteria.mask
                                });
                            }
                        });

                        metadatas.sort(function (a, b) {
                            return a.order - b.order;
                        });

                        $scope.document.metadataValues = metadatas;
                        $scope.loadActions(result[0], $scope.document);

                        var item = {};

                        $scope.document.files.forEach(function (file) {
                            item.creationDate = file.creationDate;
                            item.name = file.name;
                            item.size = file.size;
                            item.id = file.id;
                            item.stream = null;
                        });

                        $scope.previewFile(item, 0);
                    }, function () {
                        $scope.cancel();
                    });
                };

                $scope.downloadFile = function () {

                    if ($scope.document.files.length < 2) {
                        $scope.document.files.forEach(function (file) {
                            return fileWorkflowService.downloadFile(file.id).then(function (result) {

                                var success = fileDownloader.saveAs(result, file.name);

                                if (!success) {
                                    errors.showError('Api failed');
                                }

                            }, function (error) {
                                if (error.status === 204) {
                                    errors.showWarning('The document has no files');
                                } else {
                                    errors.showError('Api failed');
                                }
                            });
                        });
                    }
                    else {
                        var files = [];

                        $scope.document.files.forEach(function (file) {
                            files.push({ id: file.id, name: file.name });
                        });

                        return fileWorkflowService.downloadFilesIntoZip(files).then(function (result) {

                            var success = fileDownloader.saveAs(result.value, $translate.instant('DocumentAllFiles') + '.zip');

                            if (!success) {
                                errors.showError('Api failed');
                            }

                        }, function (error) {
                            if (error.status === 204) {
                                errors.showWarning('The document has no files');
                            } else {
                                errors.showError('Api failed');
                            }
                        });
                    }
                };

                $scope.load();
            }
        ]);
})();
